'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLocked = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _messages = require('../common/messages');

var _helpers = require('../common/helpers');

var _promises = require('../common/promises');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var deriveEventData = function deriveEventData(_ref, dictionary, eventKey, eventProperties, trackerProperties) {
  var createEvent = _ref.createEvent,
      createIdentifiers = _ref.createIdentifiers,
      isExternalHost = _ref.isExternalHost,
      logError = _ref.logError,
      onError = _ref.onError;

  var hasErrors = false;
  var wrappedOnError = function wrappedOnError() {
    hasErrors = true;
    return onError.apply(undefined, arguments);
  };
  var definition = dictionary.lookup({
    logError: logError,
    onError: wrappedOnError
  }, eventKey, eventProperties);
  var identifiers = createIdentifiers({
    email: trackerProperties.email,
    hubId: trackerProperties.hubId,
    hstc: trackerProperties.hstc
  }, isExternalHost, wrappedOnError);
  var eventPayload = createEvent(definition, eventProperties, trackerProperties, identifiers);

  if (hasErrors || !eventPayload) {
    return null;
  }

  return {
    definition: definition,
    eventPayload: eventPayload,
    identifiers: identifiers
  };
};

var parseConfig = function parseConfig(schemas, createDictionary, config) {
  var configSchema = schemas.configSchema,
      trackerPropertiesSchema = schemas.trackerPropertiesSchema;


  var parsedConfig = configSchema.normalize(config);
  configSchema.validate(parsedConfig, '"createTracker"');

  var parsedTrackerProperties = trackerPropertiesSchema.normalize(parsedConfig.properties);
  trackerPropertiesSchema.validate(parsedTrackerProperties, '"createTracker"');

  var parsedDictionary = createDictionary(parsedConfig.events, '"createTracker"');

  return _extends({
    events: parsedDictionary.definitions,
    properties: parsedTrackerProperties,
    dictionary: parsedDictionary
  }, (0, _helpers.omit)(parsedConfig, ['events', 'properties']));
};

var createLocked = exports.createLocked = function createLocked(trackerDependencies, config) {
  var createDictionary = trackerDependencies.createDictionary,
      createEvent = trackerDependencies.createEvent,
      createIdentifiers = trackerDependencies.createIdentifiers,
      logError = trackerDependencies.logError,
      logMessage = trackerDependencies.logMessage,
      onTrack = trackerDependencies.onTrack,
      schemas = trackerDependencies.schemas;


  if (!config || (typeof config === 'undefined' ? 'undefined' : _typeof(config)) !== 'object') {
    throw (0, _messages.configError)('Invalid argument. The "createTracker" function requires to be passed a config argument of type "object". Received type "' + (typeof config === 'undefined' ? 'undefined' : _typeof(config)) + '".');
  }

  var _parseConfig = parseConfig(schemas, createDictionary, config),
      dictionary = _parseConfig.dictionary,
      parsedConfig = _objectWithoutProperties(_parseConfig, ['dictionary']);

  var properties = _extends({}, parsedConfig.properties);
  var propertiesAreDirty = true;

  var lastKnownPropertyCache = {};
  var lastKnownPropertyCacheSync = function lastKnownPropertyCacheSync(eventProperties, key) {
    var value = eventProperties[key];

    if (value !== undefined) {
      lastKnownPropertyCache[key] = value;
    } else {
      value = lastKnownPropertyCache[key];
    }

    if (value && value !== properties[key]) {
      properties[key] = value;
    }
  };

  return {
    clone: function clone() {
      var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!overrides || (typeof overrides === 'undefined' ? 'undefined' : _typeof(overrides)) !== 'object') {
        throw (0, _messages.genericError)('Invalid argument. The "clone" method requires to be passed a valid tracker config of type "object". Received type "' + (typeof overrides === 'undefined' ? 'undefined' : _typeof(overrides)) + '".');
      }

      var mergedConfig = (0, _helpers.defaults)(overrides, parsedConfig);
      var supportedProperties = (0, _helpers.omit)(properties, schemas.trackerPropertiesSchema.getKeys(), false);
      var arbitraryProperties = (0, _helpers.omit)(properties, Object.keys(supportedProperties));

      mergedConfig.properties = (0, _helpers.defaults)(overrides.properties || {}, supportedProperties);

      if (parsedConfig.preserveTrackerProperties) {
        mergedConfig.properties = (0, _helpers.defaults)(mergedConfig.properties, arbitraryProperties);
      }

      return createLocked(trackerDependencies, mergedConfig);
    },

    config: _extends({}, (0, _helpers.omit)(parsedConfig, ['properties']), {
      properties: properties
    }),

    setProperties: function setProperties() {
      var newProperties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!newProperties || (typeof newProperties === 'undefined' ? 'undefined' : _typeof(newProperties)) !== 'object') {
        throw (0, _messages.genericError)('Invalid argument. The "setProperties" method requires to be passed a properties argument of type "object". Received type "' + (typeof newProperties === 'undefined' ? 'undefined' : _typeof(newProperties)) + '".');
      }

      Object.keys(newProperties).forEach(function (key) {
        var value = newProperties[key];
        properties[key] = value;
      });

      propertiesAreDirty = true;
    },

    track: function track(eventKey) {
      var eventProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!eventKey || typeof eventKey !== 'string') {
        throw (0, _messages.genericError)('Invalid argument. The "track" method requires to be passed an eventKey of type "string". Received type "' + (typeof eventKey === 'undefined' ? 'undefined' : _typeof(eventKey)) + '".');
      }

      if (!eventProperties || (typeof eventProperties === 'undefined' ? 'undefined' : _typeof(eventProperties)) !== 'object') {
        throw (0, _messages.genericError)('Invalid argument. The "track" method requires the 2nd arg to be passed eventProperties of type "object". Received type "' + (typeof eventProperties === 'undefined' ? 'undefined' : _typeof(eventProperties)) + '".');
      }

      var debug = typeof parsedConfig.debug === 'function' ? parsedConfig.debug() : parsedConfig.debug;
      var execute = function execute(trackerProperties) {
        if (parsedConfig.lastKnownEventProperties && parsedConfig.lastKnownEventProperties.length) {
          parsedConfig.lastKnownEventProperties.forEach(function (key) {
            lastKnownPropertyCacheSync(eventProperties, key);
          });
        }

        var trackerPropertiesCopy = (0, _helpers.shallowCopy)(trackerProperties);
        var eventData = deriveEventData({
          createEvent: createEvent,
          createIdentifiers: createIdentifiers,
          isExternalHost: parsedConfig.isExternalHost,
          logError: logError,
          onError: parsedConfig.onError
        }, dictionary, eventKey, eventProperties, trackerPropertiesCopy);

        if (eventData) {
          if (debug) {
            logMessage((0, _messages.debugLog)('event tracked', {
              eventKey: '"' + eventKey + '"',
              eventProperties: eventProperties,
              payload: eventData.eventPayload
            }));
          }

          onTrack({
            bypassPool: parsedConfig.bypassPool,
            isBeforeUnload: parsedConfig.isBeforeUnload,
            identifiers: eventData.identifiers
          }, eventData.eventPayload);
        }
      };

      if (propertiesAreDirty) {
        (0, _promises.resolveAsyncProperties)(properties, parsedConfig.onError, function (resolved) {
          properties = resolved;
          propertiesAreDirty = false;
          execute(resolved);
        });
      } else {
        execute(properties);
      }
    }
  };
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.74/js/tracker/factory.js
// module id = 402
// module chunks = 0